import { css } from '@bdfx/fukit'
import { plausible } from '../../common/tracking'

export default function PricingFoxCtaButton({text = null }) {

    const handleClick = () => {
        console.log("handleClick", "pf_button_click");
        plausible("pf_button_click")
    }

    return (
        <Anchor onClick={handleClick} href="https://pricing-fox.cz/?utm_source=audit_pricing&utm_medium=app" target="_blank">
            <img alt="Pricing Fox logo" src="https://cdn.bdfx.cz/muk/icons/pricingfox.svg" /> {text ?? <>Chcete monitorovat ceny automaticky? Vyzkoušejte <strong>Pricing Fox</strong></>}.
        </Anchor>
    )
}


const Anchor = css("a")({
    color: "#333 !important",
    fontSize: "1.1rem",
    textAlign: "center",
    display: "inline-block",

    cursor: "pointer",
    "img": {
        width: "24px",
        verticalAlign: "middle",
    },
    "strong": {
    },
    padding: "15px 20px",
    border: "1px solid #729A3C",
    borderRadius: "999em",
    background: "white",
    boxShadow: "2px 2px 5px rgba(0, 0, 0, .2)",
    transition: "all 0.1s",
    "&:hover,&:active,&:focus": {
        textDecoration: "none",
        background: "#f0fff0",
        boxShadow: "1px 1px 2px rgba(0, 0, 0, .2)",
        trasnform: "translate3d(1px,1px,0)",
    }
})
